import axios from "axios";
import { UserRegistration } from "./types";

export async function register(userRegistration: UserRegistration) {
  return (
    (
      await axios.post(`${process.env.REACT_APP_WANNABET_API}/users`, {
        ...userRegistration,
      })
    ).status === 200
  );
}
